<template>
  <div class="zz-main-inner">
    <div
      class="zz-main-inner-header"
      :class="{ 'no-return' : $route.meta.noReturn}">
      <!-- <div class="title">
        <span>{{ title }}</span>
        <slot name="append"></slot>
      </div>-->
      <div>
        <el-page-header
          :content="title"
          @back="goBack" />
        <slot name="append"></slot>
      </div>
      <slot name="action"></slot>
    </div>
    <div class="zz-main-content">
      <slot></slot>
      <div class="main-inner-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LayoutMainInner',
  props: {
    title: String
  },
  methods: {
    goBack() {
      console.log('go back')
      this.$router.back()
    }
  }
}
</script>
<style lang="stylus">
.zz-main-inner {
  height: 100%;
  display: flex;
  flex-direction: column;

  .zz-main-content {
    flex: 1;
    overflow: auto;
  }
  .zz-main-inner-header {
    // background-color: #fff;
    height: 48px;
    padding: 0 20px;
    background-color: #fff;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.no-return {
      .el-page-header__left {
        display: none;
      }
    }

    // margin-bottom: 10px;
    .title {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .main-inner-footer {
    // margin-top: 10px;
    text-align: center;
  }
}
</style>
